module.exports = __webpack_public_path__ + "img/pci.e51ac26.png";